import { combineReducers } from 'redux';

import paymentRequest from './payment-request';
import paymentResponse from './payment-response';
import message from './messages';
import enrollPersonRequest from './enroll-person-request';
import memberRequest from './member-request';

const reducers = combineReducers({
  paymentRequest,
  paymentResponse,
  message,
  enrollPersonRequest,
  memberRequest,
});

export default reducers;



// WEBPACK FOOTER //
// ./src/app/reducers/index.js